import { render, staticRenderFns } from "./complaintsPage.vue?vue&type=template&id=714e4b6a&scoped=true"
import script from "./complaintsPage.vue?vue&type=script&lang=js"
export * from "./complaintsPage.vue?vue&type=script&lang=js"
import style0 from "./complaintsPage.vue?vue&type=style&index=0&id=714e4b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714e4b6a",
  null
  
)

export default component.exports